import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";

import { SortableItem, SortableItemProps } from "./sortable-item";

export const SortableGroup = ({
  id,
  subItemIds,
  children,
}: {
  id: string;
  subItemIds: string[];
  children: SortableItemProps["children"];
}) => (
  <SortableItem id={id}>
    {({ dragHandleProps, isDragging, isOver }) => (
      <SortableContext
        items={subItemIds}
        strategy={verticalListSortingStrategy}
      >
        {children({ dragHandleProps, isDragging, isOver })}
      </SortableContext>
    )}
  </SortableItem>
);
